import { SecondaryButton, useModal } from '@shape-ds/components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { RecordsMessages } from '../RecordsMessages';
import './style.scss';

interface RecordsOpenModalProps {
  id: string;
}

const RecordsOpenModal: React.FC<RecordsOpenModalProps> = ({ id }: RecordsOpenModalProps) => {
  const { openModal } = useModal();
  const { t } = useTranslation();

  return (
    <SecondaryButton
      onClick={(e) => {
        e.stopPropagation();
        openModal(<RecordsMessages eventId={id} />, {
          title: t('records:event_records'),
          width: '45%',
        });
      }}
    >
      {t('records:title')}
    </SecondaryButton>
  );
};

export default RecordsOpenModal;
